import { ThemeProvider } from "styled-components";
import Header from "./components/Header";
import Card from "./components/Card";
import CardPromo from "./components/CardPromo";
import Footer from "./components/Footer";
import SocialMediaFixed from "./components/SocialMediaFixed";

const theme = {
  colors: {
    header: "#ebfbff",
    body: "#fff",
    // footer: "#003333",
    footer: "black",
  },
  mobile: "576px",
  tablet: "820px",
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <>
        <Header />
        <Card />
        <CardPromo />
        <Footer />
        <SocialMediaFixed />
      </>
    </ThemeProvider>
  );
}

export default App;
